import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import LayoutModal from "../Layout/LayoutModal";
import Pagination from "../Layout/Pagination";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { getCompanyProfile } from "../Utils/sessionUtils.js";
import AlarmApplyBox from "./AlarmApply";
import MemberAlarm from "./MemberAlarm";

const MemberApproveBox = ({ handleClickX }) => {
  const navigate = useNavigate();
  const { isEmailVisible } = getCompanyProfile();
  const [page, setPage] = useState(1);
  const [total_count, setTotal_count] = useState(0);
  const [waiting_list, setWaiting_list] = useState([]);
  const [userIdArr, setUserIdArr] = useState([]);
  const [alarmState, setAlarmState] = useState({
    show: false,
    type: "",
    title: "",
    description: "",
  });

  const getWaitingList = async () => {
    try {
      const body = {
        page: page,
        offset: 5,
      };
      const data = await postJson("/dashboard/user/getApprovalList", body, navigate);

      const _data = data.data;
      if (data.code === 200) {
        setTotal_count(_data.count);
        setWaiting_list(_data.rows);
      }
    } catch (error) {
      console.error("승인 대기 구성원 리스트 가져오기 중 에러:", error);
    }
  };

  const updateApproval = async () => {
    try {
      const body = {
        userIdArr: userIdArr,
      };
      const res = await postJson("/dashboard/user/updateApproval", body, navigate);
      if (res.code === 200) {
        await getWaitingList();
        setUserIdArr([]);
        setAlarmState({
          show: true,
          type: "",
          title: "구성원 승인 완료",
          description: "구성원이 승인되었습니다.",
        });
      } else if (res.code === 1011) {
        setAlarmState({
          show: true,
          type: "",
          title: "구성원 승인 실패",
          description: "구성원 용량이 충분한지 확인해주세요. ",
        });
      }
    } catch (error) {
      console.error("구성원 승인 중 에러:", error);
    }
  };

  const deleteApproval = async () => {
    try {
      const body = {
        userIdArr: userIdArr,
      };
      const res = await postJson("/dashboard/user/updateApproval", body, navigate);
      if (res.code === 200) {
        await getWaitingList();
        setUserIdArr([]);
        setAlarmState({
          show: true,
          type: "",
          title: "구성원 삭제 완료",
          description: "구성원이 삭제되었습니다.",
        });
      }
    } catch (error) {
      console.error("구성원 삭제 중 에러:", error);
    }
  };

  const selectAll = () => {
    waiting_list
      .slice(0, 10)
      .map((data) =>
        setUserIdArr((prev) =>
          userIdArr.includes(data.userId) ? [...prev] : [...prev, data.userId]
        )
      );
  };
  const removeAll = () => {
    waiting_list
      .slice(0, 10)
      .map((data) =>
        setUserIdArr((prev) => prev.filter((item) => item !== data.userId))
      );
  };

  useEffect(() => {
    getWaitingList();
  }, [page]);

  return (
    <Box>
      {alarmState.show &&
        (alarmState.type === "approve" ? (
          <AlarmApplyBox
            title={alarmState.title}
            subtitle={alarmState.description}
            handleApply={updateApproval}
            handleClickX={() =>
              setAlarmState({ show: false, title: "", description: "" })
            }
          />
        ) : alarmState.type === "delete" ? (
          <AlarmApplyBox
            title={alarmState.title}
            subtitle={alarmState.description}
            handleApply={deleteApproval}
            handleClickX={() =>
              setAlarmState({ show: false, title: "", description: "" })
            }
          />
        ) : (
          <MemberAlarm
            title={alarmState.title}
            description={alarmState.description}
            reloadOnConfirm={false}
            handleClickX={() =>
              setAlarmState({ show: false, title: "", description: "" })
            }
          />
        ))}
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          승인 대기 구성원
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <div
        className="hrz-wrapper"
        style={{ marginTop: "18px", height: "43px" }}
      >
        <div>
          전체 {total_count?.toLocaleString()}건 / 선택{" "}
          {userIdArr.length.toLocaleString()}건
        </div>
      </div>

      <div className="listArea" style={{ marginTop: "20px", width: "870px" }}>
        <div
          className="list_titleBar"
          style={{
            width: "870px",
            gridTemplateColumns: isEmailVisible
              ? "50px 140px 190px 240px 360px"
              : "50px 140px 190px 240px 360px",
          }}
        >
          <p className="center">
            <input
              type="checkbox"
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onChange={(e) => (e.target.checked ? selectAll() : removeAll())}
            />
          </p>
          <p className="leftalign">부서명</p>
          <p className="leftalign">닉네임</p>
          {isEmailVisible && <p className="leftalign">이메일</p>}
          <p className="leftalign">승인 요청일</p>
        </div>
      </div>
      {waiting_list.length === 0 ? (
        <div
          style={{ display: "flex", justifyContent: "center", height: "420px" }}
        >
          <p style={{ color: "#888888", marginTop: "100px" }}>
            승인 대기 구성원이 없습니다.
          </p>
        </div>
      ) : (
        <div>
          {waiting_list.slice(0, 5).map((data) => (
            <MemberData
              key={data.userId}
              userId={data.userId}
              department={data.departmentName ? data.departmentName : "없음"}
              nickName={data.nickName}
              email={data.email}
              regTime={data.regTime}
              userIdArr={userIdArr}
              setUserIdArr={setUserIdArr}
            />
          ))}
          <Pagination
            totalPages={total_count === 0 ? 1 : Math.ceil(total_count / 5)}
            currentPage={page}
            onPageChange={(pageNum) => setPage(pageNum)}
          />
        </div>
      )}
      <div style={{ display: "flex", marginTop: "20px" }}>
        <IconInfo fill="#888888" />
        <p style={{ color: "#888888", fontSize: "15px", marginLeft: "4px" }}>
          앱에서 '기업인증' 완료 후 승인 대기중인 구성원입니다. 구성원 용량을
          초과하지 않는 범위 내에서 승인할 수 있습니다.{" "}
        </p>
      </div>

      {waiting_list.length !== 0 && (
        <div style={{ display: "flex", marginTop: "40px" }} className="center">
          <div
            className="blueBorderBtn-base center"
            style={{
              width: "193px",
              height: "60px",
              borderRadius: "10px",
              boxShadow: "inset 0 0 0 1px #f25c5c",
              color: "#f25c5c",
            }}
            onClick={() =>
              setAlarmState({
                show: true,
                type: "delete",
                title: "선택한 구성원을 삭제하시겠습니까?",
                description: "승인 요청 기록이 사라집니다.",
              })
            }
          >
            삭제
          </div>
          <div
            className="blueBtn-base center"
            style={{
              width: "193px",
              height: "60px",
              borderRadius: "10px",
              marginLeft: "14px",
            }}
            onClick={() =>
              setAlarmState({
                show: true,
                type: "approve",
                title: "선택한 구성원을 승인하시겠습니까?",
                description:
                  "승인을 완료해야 구성원의 기업모드 이용이 가능합니다.",
              })
            }
          >
            승인
          </div>
        </div>
      )}
    </Box>
  );
};

const MemberData = ({
  userId,
  department,
  nickName,
  email,
  regTime,
  userIdArr,
  setUserIdArr,
}) => {
  const { isEmailVisible } = getCompanyProfile();

  const handleSelect = () => {
    setUserIdArr((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((item) => item !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };
  return (
    <RowWrapper $isEmailVisible={isEmailVisible}>
      <p className="center">
        <input
          type="checkbox"
          style={{ width: "20px", height: "20px" }}
          checked={userIdArr.includes(userId)}
          onChange={() => handleSelect(userId)}
        />
      </p>
      <p className="leftalign">{department}</p>
      <p className="leftalign">{nickName}</p>
      {isEmailVisible && <p className="leftalign">{email}</p>}
      <p className="leftalign">{regTime}</p>
    </RowWrapper>
  );
};

const MemberApprove = ({ handleClickX }) => {
  return (
    <LayoutModal Modal={<MemberApproveBox handleClickX={handleClickX} />} />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const RowWrapper = styled.div`
  width: 870px;
  height: 56px;
  box-shadow: inset 0 -1px 0 0 #e4e4e4;
  display: grid;
  grid-template-columns: ${(props) =>
    props.$isEmailVisible
      ? "50px 140px 190px 240px 360px"
      : "50px 140px 190px 600px"};
  color: #222222;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

export default MemberApprove;
